import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { EditableProvider } from "./context/EditableContext";
import { AuthProvider } from "./context/AuthContext";

// Component to reset body styles on route change (fixes body lock issue from Radix UI modals/dialogs)
const BodyStyleReset = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Reset body overflow on every route change to prevent body lock issues
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.style.marginRight = '';
    document.body.style.pointerEvents = '';
    
    // Remove any data attributes that Radix UI might have added
    document.body.removeAttribute('data-scroll-locked');
    
    return () => {
      // Cleanup on unmount
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.style.marginRight = '';
      document.body.style.pointerEvents = '';
    };
  }, [location.pathname]);
  
  return null;
};
import HomePage from "./pages/HomePage";
import SchoolsPage from "./pages/SchoolsPage";
import SchoolDetailPage from "./pages/SchoolDetailPage";
import EcolesPage from "./pages/EcolesPage";
import EcoleDetailPage from "./pages/EcoleDetailPage";
import ExamResultsPage from "./pages/ExamResultsPage";
import StatisticsPage from "./pages/StatisticsPage";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import ExamPage from "./pages/ExamPage";
import FinalExamPage from "./pages/FinalExamPage";
import OrganizationPage from "./pages/OrganizationPage";
import ArchiveManagementPage from "./pages/ArchiveManagementPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import SMSMessagingPage from "./pages/SMSMessagingPage";
import TeacherManagementPage from "./pages/TeacherManagementPage";
import TeachingMaterialsPage from "./pages/TeachingMaterialsPage";
import SchoolManagementPage from "./pages/SchoolManagementPage";
import BulkImportPage from "./pages/BulkImportPage";

function App() {
  return (
    <AuthProvider>
      <EditableProvider>
        <div className="App">
          <BrowserRouter>
            <BodyStyleReset />
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/* English Schools */}
              <Route path="/schools" element={<SchoolsPage />} />
              <Route path="/school/:schoolId" element={<SchoolDetailPage />} />
              {/* French Schools */}
              <Route path="/ecoles" element={<EcolesPage />} />
              <Route path="/ecole/:schoolId" element={<EcoleDetailPage />} />
              {/* Other Pages */}
              <Route path="/exam-results" element={<ExamResultsPage />} />
              <Route path="/statistics" element={<StatisticsPage />} />
              <Route path="/organization" element={<OrganizationPage />} />
              <Route path="/archive" element={<ArchiveManagementPage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
              <Route path="/admin/sms" element={<SMSMessagingPage />} />
              <Route path="/admin/teachers" element={<TeacherManagementPage />} />
              <Route path="/admin/school-management" element={<SchoolManagementPage />} />
              <Route path="/admin/bulk-import" element={<BulkImportPage />} />
              <Route path="/teaching-materials" element={<TeachingMaterialsPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              {/* Exam Pages */}
              <Route path="/exam/:schoolId" element={<ExamPage />} />
              <Route path="/exam/:schoolId/final" element={<FinalExamPage />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
      </EditableProvider>
    </AuthProvider>
  );
}

export default App;
